import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation } from "react-apollo";

import { Button, Fieldset, Field, Control } from "rbx";
import Section from "../Section";

import { CREATE_TARIFF_MUTATION } from "../../graphql/Tariffs/Tariffs.graphql";
import { getUTCFormattedDate, ourToast as toast } from "../../utils";

import TariffForm from "./TariffForm";

class AddTariffForm extends Component {
  state = {
    TariffTypeRecIdRef: "",
    TariffCode: "",
    Description: "",
    BeginDate: "",
    EndDate: "",
    MinLoad: "",
    MaxLoad: "",
    MinCharge: "",
    Active: true
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const { setModalOpen } = this.props;
    const {
      TariffCode,
      Description,
      BeginDate,
      EndDate,
      MinLoad,
      MaxLoad,
      MinCharge,
      TariffTypeRecIdRef,
      Active
    } = this.state;
    return (
      <Section title="Add Tariff">
        <Mutation
          mutation={CREATE_TARIFF_MUTATION}
          refetchQueries={["ALL_TARIFFS_QUERY"]}
          variables={{
            data: {
              TariffTypeRecIdRef: parseInt(TariffTypeRecIdRef),
              TariffCode,
              Description,
              BeginDate: BeginDate ? getUTCFormattedDate(BeginDate) : null,
              EndDate: EndDate ? getUTCFormattedDate(EndDate) : null,
              Active,
              MinLoad: parseInt(MinLoad),
              MaxLoad: parseInt(MaxLoad),
              MinCharge: parseInt(MinCharge)
            }
          }}
        >
          {(createTariff, { loading, error }) => (
            <form
              method="POST"
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await createTariff();
                  setModalOpen(false);
                  toast.success("Tariff created successfully.");
                } catch (err) {
                  toast.error("Error creating Tariff.");
                }
              }}
            >
              <Fieldset disabled={loading}>
                <TariffForm
                  inputs={{
                    TariffCode,
                    Description,
                    BeginDate,
                    EndDate,
                    MinLoad,
                    MaxLoad,
                    MinCharge,
                    Active
                  }}
                  onChange={this.onChange}
                />
                <hr />
                <Field kind="group">
                  <Control>
                    <Button color="success" type="submit">
                      Submit
                    </Button>
                  </Control>
                  <Control>
                    <Button type="button" onClick={() => setModalOpen(false)}>
                      Cancel
                    </Button>
                  </Control>
                </Field>
              </Fieldset>
            </form>
          )}
        </Mutation>
      </Section>
    );
  }
}

AddTariffForm.propTypes = {
  setModalOpen: PropTypes.func
};

export default AddTariffForm;
